// @ts-nocheck
import { BasicMagnet } from "../BasicMagnet";
import { s } from "../../shared/globalState/settings";

export class Grip extends BasicMagnet {
    private _center: any;
    width: any;
    height: any;
    type: string;
    color: number[];
    ownerId: any;
    ownerSide: any;

    get center() {
        return this._center;
    }
    set center(point) {
        this._center = point.clone();
    }

    constructor(center, ownerId=null, ownerSide = null) {
        super();

        this._center = { ...center };
        this.width = s.tolerance;
        this.height = s.tolerance;

        this.type = 'm_grip';

        this.color = [0, 1, 0, 1];

        this.ownerId = ownerId;
        this.ownerSide = ownerSide;
    }

    getVertices() {
        return new Float32Array([
            this.center.x - this.width / 2, this.center.y + this.height / 2,
            this.center.x + this.width / 2, this.center.y + this.height / 2,
            this.center.x + this.width / 2, this.center.y - this.height / 2,
            this.center.x - this.width / 2, this.center.y - this.height / 2,
        ]);

    }

    isin(point, mouse) {
        const minX = point.x - s.tolerance ;
        const maxX = point.x + s.tolerance ;
        const minY = point.y - s.tolerance;
        const maxY = point.y + s.tolerance;

        return (mouse.x >= minX && mouse.x <= maxX && mouse.y >= minY && mouse.y <= maxY);
    }



}